import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { defaultTemplate } from "common/hoc";

function ContentModeInfoModalTemplate({ modalParams, t }) {
    return (
        <MrbModal
            className="modal__content modal__content--xlrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={true}
            displayCloseIcon={true}
        >
            <div className="u-type--base u-mar--top--sml">
                <p className="u-mar--bottom--sml">
                    {t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.TITLE")}
                </p>

                <div className="c-card--sml c-card--secondary u-type--base u-mar--bottom--sml">
                    <strong>
                        {t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.THE_NAKI_STANDARD")}
                    </strong>
                    <br />
                    <p className="u-type--color--text--lighter">
                        {t(
                            "APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.THE_NAKI_STANDARD_DESCRIPTION"
                        )}
                    </p>
                </div>

                <div className="c-card--sml c-card--secondary u-type--base u-mar--bottom--sml">
                    <strong>{t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.WHITELIST_MODE")}</strong>
                    <p className="u-type--color--text--lighter">
                        {t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.WHITELIST_MODE_DESCRIPTION")}
                    </p>
                    <div className="u-display--flex">
                        <p className="c-validation--info u-mar--top--tny">
                            {t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONTENT_MODES.EXPLANATION.WHITELIST_MODE_NOTE")}
                        </p>
                    </div>
                </div>
            </div>
        </MrbModal>
    );
}

ContentModeInfoModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(ContentModeInfoModalTemplate);
